import { Text, Box } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

import { SalaryRange, SalarySuffixTypes } from 'components/atoms/salaryRange';
import { RangeSlider } from 'components/molecules/form/rangeSlider';
import { useJobFilters } from 'lib/repositories/jobsShowcaseFilters';

import { MobileFilterCard } from '../card';

export interface SalaryProps {
  handleSearchJobs(): void;
  defaultSalaryValues: Array<number>;
}

export const Salary = ({
  handleSearchJobs,
  defaultSalaryValues,
}: SalaryProps) => {
  const { filters, setFilters } = useJobFilters();
  const [salaryRangeValue, setSalaryRangeValue] = useState<Array<number>>([
    defaultSalaryValues[0],
    defaultSalaryValues[1],
  ]);

  const onValueChangeEnd = ([min, max]: number[]) => {
    setFilters({ ...filters, maxSalary: max, minSalary: min });
  };

  const onValueChange = (value: number[]) => {
    setSalaryRangeValue(value);
  };

  const resetFilter = () => {
    setFilters({
      ...filters,
      minSalary: defaultSalaryValues[0],
      maxSalary: defaultSalaryValues[1],
    });
    setSalaryRangeValue([defaultSalaryValues[0], defaultSalaryValues[1]]);
  };

  useEffect(() => {
    setSalaryRangeValue([
      filters.minSalary || defaultSalaryValues[0],
      filters.maxSalary || defaultSalaryValues[1],
    ]);
  }, [defaultSalaryValues, filters.minSalary, filters.maxSalary]);

  return (
    <MobileFilterCard
      isActive={
        (filters.minSalary !== defaultSalaryValues[0] &&
          filters.minSalary !== undefined) ||
        (filters.maxSalary !== defaultSalaryValues[1] &&
          filters.maxSalary !== undefined)
      }
      showTooltip={false}
      showResetFilter
      resetFilter={resetFilter}
      label='Remuneração'
      title='Remuneração'
      handleSearchJobs={handleSearchJobs}
    >
      <Text fontWeight={600}>Faixa de remuneração mensal</Text>

      <SalaryRange
        minSalary={salaryRangeValue[0]}
        maxSalary={salaryRangeValue[1]}
        currency='R$'
        suffix={SalarySuffixTypes.None}
      />

      <Box px={3}>
        <RangeSlider
          min={defaultSalaryValues[0]}
          max={defaultSalaryValues[1]}
          onChangeEnd={onValueChangeEnd}
          onChange={onValueChange}
          value={salaryRangeValue}
          defaultValue={[
            filters.minSalary || defaultSalaryValues[0],
            filters.maxSalary || defaultSalaryValues[1],
          ]}
          mt={9}
        />
      </Box>
    </MobileFilterCard>
  );
};
